import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Page-css/ClientNavbar.css";
import { useAuth } from "../../Context/UserContext";
import { Icon } from "@iconify/react";

const ClientNavbar = () => {
  const {
    user,
    isSidebarCollapsed,
    fetchUnreadMessageCount,
    count,
    userPermission,
    isAuthenticated
  } = useAuth();

  const firstLetter = user ? user.charAt(0).toUpperCase() : "";



  const location = useLocation();
  const { pathname } = location;

  const isCurrentPage = (page) => {
    return page === pathname;
  };


  useEffect(() => {
    if (!isAuthenticated) return;
    fetchUnreadMessageCount();
    const intervalId = setInterval(() => {
      fetchUnreadMessageCount();
    }, 120000);

    return () => clearInterval(intervalId);
  }, []);


  return (
    <div className={isSidebarCollapsed ? "wrap_newnavbar_client" : "wrap_close_navbar"}>


      {isSidebarCollapsed ? (
        <div className="new_navbar_links_client">
          <Link
            to="/client_dashboard"
            style={{
              color: "white",
              backgroundColor:
                window.location.pathname === "/client_dashboard" ||
                  window.location.pathname.startsWith("/viewvulnerabilities/")
                  ? "#E76A34"
                  : "",
            }}
          >
            <span className="nav-icon">
              <Icon icon="ri:dashboard-line" width="19" height="19" />
            </span>
            Dashboard
          </Link>


          <Link
            to="/projects/all"
            style={{
              color:
                window.location.pathname === "/projects/all" ||
                  window.location.pathname.startsWith("/client/project/status")
                  ? "white"
                  : "white",
              backgroundColor:
                window.location.pathname === "/projects/all" ||
                  window.location.pathname.startsWith(
                    "/client/project/status"
                  ) ||
                  window.location.pathname.startsWith(
                    "/client/project/vulnerabilitystatus"
                  )
                  ? "#E76A34"
                  : "",
            }}
          >
            <span className="nav-icon">
              <Icon icon="clarity:folder-open-line" width="19" height="19" />
            </span>{" "}
            Projects
          </Link>

          {(userPermission === "level 4") && (
            <>
              <Link
                to="/openvulnerabilities"
                className="nav-link-with-tooltip"

                style={{
                  color: isCurrentPage("/openvulnerabilities") ? "white" : "white",
                  backgroundColor: isCurrentPage("/openvulnerabilities")
                    ? "#E76A34"
                    : "",
                }}
              >
                <span className="nav-icon">
                  <Icon icon="solar:bug-linear" width="19" height="19" />
                </span>{" "}
                Vulnerabilities
              </Link>
            </>
          )}



          {(userPermission === "level 1" || userPermission === "level 2") && (
            <>
              <Link
                to="/client/register developer"
                style={{
                  color: isCurrentPage("/client/register%20developer")
                    ? "white"
                    : "white",
                  backgroundColor: isCurrentPage(
                    "/client/register%20developer"
                  )
                    ? "#E76A34"
                    : "",
                }}>
                <span className="nav-icon">
                  <Icon icon="lucide:user" width="19" height="19" />
                </span>
                Manage Users
              </Link>
            </>
          )}
          <Link
            to="/client/chatbox"
            style={{
              color: "white",
              backgroundColor: isCurrentPage("/client/chatbox")
                ? "#E76A34"
                : "",
              position: "relative"
            }}
          >
            <span className="nav-icon" style={{ position: "relative" }}>
              <Icon icon="mingcute:message-2-line" width="19" height="19" />
              {count > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: "-5px",
                    right: "-5px",
                    background: "#E76A34",
                    color: "white",
                    borderRadius: "50%",
                    padding: "2px 5px",
                    fontSize: "10px"
                  }}
                >
                  {count > 9 ? '9+' : count}
                </span>
              )}
            </span>
            Chatbox
          </Link>

        </div>
      ) : (
        <div className="nav_links_client">
          <Link
            to="/client_dashboard"
            className="nav-link-with-tooltip"
            style={{
              color: "white",
              backgroundColor:
                window.location.pathname.startsWith("/client_dashboard") ||
                  window.location.pathname.startsWith("/viewvulnerabilities")
                  ? "#E76A34"
                  : "",
              padding: "9px 8px 8px 7.5px",
              // margin: "4px 3.5px",
            }}
          >
            <span className="icon_size">
              <Icon icon="ri:dashboard-line" width="19" height="19" />
            </span>
            <span className="tooltip-text">Dashboard</span>
          </Link>

          <Link
            to="/projects/all"
            className="nav-link-with-tooltip"
            style={{
              color:
                window.location.pathname === "/projects/all" ||
                  window.location.pathname.startsWith("/client/project/status")
                  ? "white"
                  : "white",
              backgroundColor:
                window.location.pathname === "/projects/all" ||
                  window.location.pathname.startsWith(
                    "/client/project/status"
                  ) ||
                  window.location.pathname.startsWith(
                    "/client/project/vulnerabilitystatus"
                  )
                  ? "#E76A34"
                  : "",
              padding: "8px ",
              // margin: "4px 3.5px",
            }}
          >
            <span className="icon_size">
              <Icon icon="clarity:folder-open-line" width="19" height="19" />
            </span>
            <span className="tooltip-text">Projects</span>

          </Link>
          {(userPermission === "level 1" || userPermission === "level 2") && (
            <>
              <Link
                to="/client/register developer"
                className="nav-link-with-tooltip"

                style={{
                  color: isCurrentPage("/client/register%20developer")
                    ? "white"
                    : "white",
                  backgroundColor: isCurrentPage(
                    "/client/register%20developer"
                  )
                    ? "#E76A34"
                    : "",
                  padding: "8px",
                  // margin: "4px 3.5px",
                }}
              >
                <span className="icon_size">
                  <Icon icon="lucide:user" width="19" height="19" />
                </span>
                <span className="tooltip-text">Manage Users</span>

              </Link>
            </>
          )}

          {(userPermission === "level 4") && (
            <Link
              to="/openvulnerabilities"
              className="nav-link-with-tooltip"

              style={{
                color: isCurrentPage("/openvulnerabilities") ? "white" : "white",
                backgroundColor: isCurrentPage("/openvulnerabilities")
                  ? "#E76A34"
                  : "",
                padding: "8px",
                // margin: "4px 3.5px",
              }}
            >
              <span className="icon_size">
                <Icon icon="solar:bug-linear" width="19" height="19" />
              </span>
              <span className="tooltip-text">Vulnerabilities</span>

            </Link>
          )}

          <Link
            to="/client/chatbox"
            className="nav-link-with-tooltip"
            style={{
              color: "white",
              backgroundColor: isCurrentPage("/client/chatbox")
                ? "#E76A34"
                : "",
              padding: "8px",
              position: "relative"
            }}
          >
            <span className="icon_size" style={{ position: "relative" }}>
              <Icon icon="mingcute:message-2-line" width="19" height="19" />
              {count > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: "-4px",
                    right: "-6px",
                    background: "#E76A34",
                    color: "white",
                    borderRadius: "50%",
                    width: "18px",
                    height: "18px",
                    fontSize: "10px",
                    // lineHeight: "1"
                    display: "flex",
                    justifyContent: 'center',
                    alignItems: "center",
                    alignSelf: "center"
                  }}
                >
                  {count > 9 ? '9+' : count}
                </span>
              )}
            </span>

            <span className="tooltip-text">Chatbox</span>
          </Link>
        </div>
      )}
    </div>

  );
};

export default ClientNavbar;
